import React, { useState, useEffect } from "react";
import { BsFillSendFill } from "react-icons/bs";


const DescriptionModal = ({ onClose, description, product_name, onSave }) => {
    const [localDescription, setLocalDescription] = useState(description || '');
  // Update local state whenever the description prop changes
  useEffect(() => {
    setLocalDescription(description);
  }, [description]);

  
  const handleSave = () => {  // Handle saving the result and closing the modal
    onSave(localDescription); // Send the updated description to the parent
    onClose(); // Close the modal after saving
  };

 

  
  
  

  return (
    <div className="">
      <div className="flex">
        <h2 className="text-blue-700 mb-3 text-1xl font-bold text-center pb-2">Edit Description</h2>
      </div>
      <div className="modal-content">
               
      <div className="bg-gray-50 border border-gray-100 rounded-lg py-2 px-4 mx-auto">
          {/* Product Name Display */}
          <div className="mb-6">
            <label className="text-gray-700 font-medium">Product Name:</label>
            <div className="text-gray-500  bg-white p-2 mt-1 border border-gray-100 rounded-lg mt-1">{product_name || 'No product name provided'}</div>
          </div>

          {/* Description Label and Textarea */}
          <div className="">
            <label htmlFor="description" className="block font-medium text-gray-600 mb-2">
              Product Description
            </label>
            <textarea
          
              value={localDescription}
              // Use onChange to update the local state as user types
              onChange={(e) => setLocalDescription(e.target.value)} // This will allow editing
              className="w-full p-4 border-2 border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-500 focus:ring-2 focus:ring-indigo-500 focus:outline-none text-lg transition-all duration-300"
              rows={2}
              placeholder="Enter product description..."
            />
          </div>
        </div>

        
      </div>
      <div className="flex justify-end mt-2">
                <button
                  onClick={handleSave} // Call handleSave to update the parent with the new description
                  className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-6 rounded-md flex items-center space-x-2 shadow-md hover:shadow-lg transition-all duration-200"
                >
                  <BsFillSendFill className="text-white" />
                  <span>Save</span>
                </button>
              </div>
    </div>
  );
};

export default DescriptionModal;
